import React from 'react';

const Features = () => {
  return (
    <section style={{ backgroundColor: '#F4F3F8' }}>
      <div className='container py-5'>
        <div className='row'>
          <div className='col-12'>
            <h2 className='text-center font-weight-bold mb-5'>Features</h2>
          </div>
          <div className='col-lg-5'>
            <div className=''>
              <div className='row py-3 align-items-center'>
                <div className='col col-md-2 col-lg-3 mr-md-3 px-xxl-3'>
                  <span className='icon-box mx-auto mx-md-0'>
                    <img
                      height={50}
                      src={require('../../resources/server.svg').default}
                      alt='bbc'
                      className='mw-100'
                    />
                  </span>
                </div>
                <div className='col-12 col-md-8 col-xxl-7 mt-4 mt-md-0 text-center text-md-left'>
                  <h6 className='font-weight-bold'>Real Time UOA Tracker</h6>
                  <p className='h6 font-weight-light text-black-50'>
                    OptionFalcon's algorithm monitors the smart money and tracks
                    unusual option activities in the option market
                  </p>
                </div>
              </div>
              <div className='row py-3 align-items-center'>
                <div className='col col-md-2 col-lg-3 mr-md-3 px-xxl-3'>
                  <span className='icon-box mx-auto mx-md-0'>
                    <img
                      height={50}
                      src={require('../../resources/data-storage.svg').default}
                      alt='abc'
                      className='mw-100'
                    />
                  </span>
                </div>
                <div className='col-12 col-md-8 col-xxl-7 mt-4 mt-md-0 text-center text-md-left'>
                  <h6 className='font-weight-bold'>
                    Interactive Online Database
                  </h6>
                  <p className='h6 font-weight-light text-black-50'>
                    Use real-time data analytics to get ahead of the market with
                    detailed insights such as relative volume and trade
                    initiation.
                  </p>
                </div>
              </div>
              <div className='row py-3 align-items-center'>
                <div className='col col-md-2 col-lg-3 mr-md-3 px-xxl-3'>
                  <span className='icon-box mx-auto mx-md-0'>
                    <img
                      height={50}
                      src={require('../../resources/elearning.svg').default}
                      alt='ab'
                      className='mw-100'
                    />
                  </span>
                </div>
                <div className='col-12 col-md-8 col-xxl-7 mt-4 mt-md-0 text-center text-md-left'>
                  <h6 className='font-weight-bold'>Daily Market Summary</h6>
                  <p className='h6 font-weight-light text-black-50'>
                    Access in-depth EOD report that provides you insights such
                    as top unusual tickers, relative volume, trend, and market
                    sentiment
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Divider Line Start */}
          <div className='col d-none d-lg-flex justify-content-end'>
            <span
              className='d-flex h-100 rounded-pill'
              style={{ width: 2, backgroundColor: '#ddd' }}
            ></span>
          </div>
          <div className='my-3 pb-3 border-top w-100 d-lg-none'></div>
          {/* Divider Line End */}
          <div className='col-lg-6'>
            <div className='text-center mb-4'>
              <h6 className='font-weight-bolder text-capitalize'>
              OptionFalcon Tracks
              </h6>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <div className='text-center'>
                  <div>
                    <img
                      height={100}
                      src={require('../../resources/image-1.jpg').default}
                      alt='ab'
                      className='mw-100'
                    />
                  </div>
                  <div className='my-3'>
                    <button
                      type='button'
                      className='btn btn-call btn-sm rounded-pill text-white py-1 px-3'
                    >
                      <span className='text-capitalize'>Sweep Order</span>
                    </button>
                  </div>
                  <div className='text-lg-left'>
                    <p className='text-black-50'>
                      Stealthy order that are executed across multiple exchange
                      disgussed as numerous individual small orders. Our
                      algorithem tracks and consolidated them as one order so
                      you can see the true size and diresction of these orders.
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='text-center'>
                  <div>
                    <img
                      height={100}
                      src={require('../../resources/image-2.jpg').default}
                      alt='ab'
                      className='mw-100'
                    />
                  </div>
                  <div className='my-3'>
                    <button
                      type='button'
                      className='btn btn-call btn-sm rounded-pill text-white py-1 px-3'
                    >
                      <span className='text-capitalize'>Block Order</span>
                    </button>
                  </div>
                  <div className='text-lg-left'>
                    <p className='text-black-50'>
                      Large orders mainly made by institutional investors and
                      are privately executed outside of the exchange, but still
                      must be reported to the exchange. OptionFalcon's algorithem
                      scans the exchange market and alerts you of block trade as
                      they happen.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
